(() => {
  'use strict';
  const root = document.documentElement;
  const hero = document.querySelector('[data-dm-campaign-hero]');
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const toggles = [...document.querySelectorAll('[data-dm-builder-motion]')];
  const flights = new Set();
  const celebrations = new Set();
  let paused = false;
  try { paused = sessionStorage.getItem('dm-campaign-motion-paused') === 'true'; } catch (_) {}
  const allowed = () => !paused && !reduced.matches && !window.Shopify?.designMode && hero?.dataset.motionEnabled !== 'false';

  function clear() {
    [...flights].forEach(flight => flight.remove());
    [...celebrations].forEach(animation => animation.cancel());
    celebrations.clear();
  }
  function update() {
    if (!hero) root.dataset.dmCampaignMotion = allowed() ? 'on' : 'off';
    toggles.forEach(toggle => {
      toggle.hidden = reduced.matches || Boolean(window.Shopify?.designMode);
      toggle.textContent = allowed() ? toggle.dataset.pauseLabel : toggle.dataset.resumeLabel;
    });
    if (!allowed()) clear();
  }
  toggles.forEach(toggle => toggle.addEventListener('click', () => {
    paused = !paused;
    try { sessionStorage.setItem('dm-campaign-motion-paused', String(paused)); } catch (_) {}
    update();
    document.dispatchEvent(new CustomEvent('dm:motion-preference', {detail:{paused}}));
  }));
  document.addEventListener('dm:motion-preference', event => { paused = event.detail.paused; update(); });
  reduced.addEventListener('change', update);
  document.addEventListener('visibilitychange', () => { if (document.hidden) clear(); });
  document.addEventListener('dm:builder-closed', clear);

  function visible(element) {
    if (!element?.isConnected || element.closest('[hidden]')) return null;
    const bounds = element.getBoundingClientRect();
    return bounds.width > 0 && bounds.height > 0 && bounds.bottom > 0 && bounds.top < innerHeight && bounds.right > 0 && bounds.left < innerWidth ? bounds : null;
  }
  function celebrate(preview) {
    if (!preview?.isConnected || !allowed() || !preview.animate) return;
    const animation = preview.animate([{transform:'scale(1)'},{transform:'scale(1.035)',offset:.45},{transform:'scale(1)'}], {duration:360,easing:'ease-out'});
    celebrations.add(animation);
    animation.onfinish = animation.oncancel = () => celebrations.delete(animation);
  }
  document.addEventListener('dm:flavour-added', event => {
    if (!allowed() || document.hidden) return;
    const {source, destination, preview, complete} = event.detail;
    const start = visible(source), end = visible(destination);
    if (!start || !end || !source.animate) { if (complete) celebrate(preview); return; }
    while (flights.size >= 3) flights.values().next().value.remove();
    const image = document.createElement('img');
    image.className = 'dm-product-flight';
    image.src = source.currentSrc || source.src;
    image.alt = '';
    image.setAttribute('aria-hidden', 'true');
    image.inert = true;
    const size = Math.min(start.width, start.height, 84);
    const left = Math.max(0, Math.min(innerWidth - size, start.left + (start.width - size) / 2));
    const top = Math.max(0, Math.min(innerHeight - size, start.top + (start.height - size) / 2));
    Object.assign(image.style, {left:`${left}px`,top:`${top}px`,width:`${size}px`,height:`${size}px`});
    document.body.append(image);
    const dx = end.left + end.width / 2 - left - size / 2;
    const dy = end.top + end.height / 2 - top - size / 2;
    const scale = Math.max(.1, Math.min(1, end.width / size));
    const lift = Math.min(70, Math.max(12, top + dy * .5));
    let animation;
    let timer;
    let removed = false;
    const flight = {remove() {
      if (removed) return;
      removed = true;
      clearTimeout(timer);
      animation?.cancel();
      image.remove();
      flights.delete(flight);
    }};
    flights.add(flight);
    try {
      animation = image.animate([
        {transform:'translate3d(0,0,0) scale(1) rotate(0deg)',opacity:1},
        {transform:`translate3d(${dx*.5}px,${dy*.5-lift}px,0) scale(.8) rotate(-8deg)`,opacity:1,offset:.5},
        {transform:`translate3d(${dx}px,${dy}px,0) scale(${scale}) rotate(0deg)`,opacity:.6}
      ], {duration:620,easing:'cubic-bezier(.22,.68,.35,1)',fill:'forwards'});
      animation.onfinish = () => { flight.remove(); if (complete && preview.classList.contains('is-complete')) celebrate(preview); };
      animation.oncancel = () => flight.remove();
      timer = setTimeout(() => flight.remove(), 900);
    } catch (_) { flight.remove(); if (complete) celebrate(preview); }
  });
  update();
})();
